import { TypedFilter } from "odata-query";
import { TIME_UNITS } from "@miplatform/constants";
import { IDateRangeISO } from "@miplatform/types";
import { endOf, startOf } from "../date/date";

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
export const combineCalendarFilters = <T extends unknown>({
  dateRange,
  filtersArray = [],
  templateIdFilters = [],
}: {
  dateRange?: IDateRangeISO;
  filtersArray?: TypedFilter<T>[];
  templateIdFilters?: string[];
}): TypedFilter<T> => {
  let dateFilter = {};
  if (dateRange) {
    const startDay = startOf(TIME_UNITS.DAY, dateRange.startDate);
    const endDay = endOf(
      TIME_UNITS.DAY,
      dateRange.endDate ?? dateRange.startDate
    );
    dateFilter = {
      approvedStartDate: {
        ge: startDay.toDate(),
        le: endDay.toDate(),
      },
    };
  }

  // Flatten all filters from filtersArray into one object
  const mergedFilters =
    filtersArray && filtersArray.length > 0
      ? Object.assign({}, ...filtersArray)
      : {};

  const templateIdFilter = templateIdFilters?.length
    ? { templateId: { in: templateIdFilters } }
    : {};

  const combinedFilter: TypedFilter<T> = {
    ...dateFilter,
    ...mergedFilters,
    ...templateIdFilter,
  };

  return combinedFilter;
};
